import React, { useState } from 'react';
import {
  withDatasourceCheck,
  Text as JssText,
  RichText as JssRichText,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { FAQsProps } from '@greystar/ui/src/component-props';
import { HeaderTextBlock } from '@greystar/designsystem';

const FAQs = (props: FAQsProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const heading = props.fields?.data?.datasource?.heading;
  const items = props.fields?.data?.datasource?.children?.results || [];

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const headingStyles = props?.params?.headingStyles as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  return (
    <div className="faqs-container">
      {heading && (
        <HeaderTextBlock direction="reverse">
          <HeaderTextBlock.Header
            as={headingStyles}
            header={<JssText field={heading} as={props.params?.headingStyles ?? undefined} />}
          />
        </HeaderTextBlock>
      )}

      {items.length > 0 ? (
        <div className="faq-items">
          {items.map((item, index) => (
            <div key={item.id} className="faq-item">
              {' '}
              {/* Use item.id as the key */}
              <button
                className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeIndex === index}
              >
                <JssText field={{ value: item.question.value }} />
                <span className="faq-toggle">{activeIndex === index ? '−' : '+'}</span>
              </button>
              {activeIndex === index && (
                <div className="faq-answer" aria-hidden={activeIndex !== index}>
                  <JssRichText field={{ value: item.answer.value }} />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="faq-no-items">No questions available</div>
      )}
    </div>
  );
};

export default withDatasourceCheck()<FAQsProps>(FAQs);
